import { Dumbbell } from 'lucide-react';
import { Link } from 'react-router-dom';

function MetricChip({ value, label, highlight }) {
  return (
    <div className="bg-[#0F0F0F] rounded-md p-2">
      <p className={`font-mono text-lg font-bold ${highlight ? 'text-[#FF6B35]' : 'text-white'}`}>{value}</p>
      <p className="text-[10px] text-zinc-400 uppercase">{label}</p>
    </div>
  );
}

export function TodayExercisesCard({ todayExercises }) {
  if (!todayExercises?.totals?.exercise_count) return null;
  return (
    <div className="bg-[#1B1B1B] border border-[#2A2A2E] rounded-lg p-4" data-testid="today-exercises-dashboard">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-xl text-white" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
          <Dumbbell className="w-5 h-5 text-[#FF6B35] inline mr-1 mb-0.5" /> Exercices du jour
        </h2>
        <Link to="/entrainement?tab=exercices" className="text-xs text-[#FF6B35] font-semibold">Tout voir</Link>
      </div>
      <div className="grid grid-cols-4 gap-2 text-center mb-3">
        <MetricChip value={todayExercises.totals.effort_score.toLocaleString()} label="effort" highlight />
        <MetricChip value={todayExercises.totals.exercise_count} label="exos" />
        <MetricChip value={todayExercises.totals.total_sets} label="series" />
        <MetricChip value={todayExercises.totals.total_reps} label="reps" />
      </div>
      {todayExercises.exercises.slice(0, 3).map((ex) => (
        <div key={ex.id} className="flex items-center justify-between text-sm py-1">
          <span className="text-zinc-300 truncate flex-1">{ex.exercise_name || ex.exercise_type}</span>
          <span className="text-zinc-500 ml-2 font-mono text-xs">{ex.sets}x{ex.reps}{ex.weight ? ` · ${ex.weight}kg` : ''}</span>
        </div>
      ))}
    </div>
  );
}
